/* Booster-box purchase limit + product-card UX cleanup — storefront layer.
   Also hides the quick-add qty selectors so product cards can only "Add to
   cart" 1 at a time, never bulk-add. PDP cap at LIMIT applies only to
   booster-box products (productType ends "Booster Box"). */

(function injectStyles() {
  // (a) Hide every qty selector inside product cards + quick-add modals so
  //     listing pages can only Add to cart 1 at a time. Cart page + product
  //     page qty inputs aren't matched by these selectors and stay intact.
  var css = ''
    + '.card-wrapper quantity-input,'
    + '.product-card-wrapper quantity-input,'
    + '.quick-add-modal quantity-input,'
    + '.card-information quantity-input { display: none !important; }';
  var s = document.createElement('style');
  s.id = 'tcc-card-qty-hide';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
})();

/* Cart-layer multi-line enforcement: any *-BOX SKU pushed above LIMIT (5)
   gets clamped via /cart/update.js + toast. Click capture intercepts
   checkout buttons. Cart-page qty inputs are capped + "+" button disabled
   at 5. PDP for booster-box products also caps qty input at 5. */
(function () {
  var BOX_SKU_REGEX = /-BOX$/i;
  var LIMIT = 5;
  var MESSAGE = "You've reached your limit for this item. To order more, email alex@thechase.club.";
  var POLL_MS = 400;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function isBoxSku(s) { return BOX_SKU_REGEX.test(s || ''); }

  // ── toast ───────────────────────────────────────────────────────────
  var lastToastAt = 0;
  function showToast() {
    var now = Date.now();
    if (now - lastToastAt < 1500) return;  // dedupe rapid-fire
    lastToastAt = now;
    var existing = document.getElementById('tcc-box-limit-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'tcc-box-limit-toast';
    t.textContent = MESSAGE;
    t.style.cssText = [
      'position:fixed', 'top:24px', 'left:50%',
      'transform:translateX(-50%)', 'z-index:99999',
      'background:#1a1a1a', 'color:#cba135', 'border:2px solid #cba135',
      'padding:14px 20px', 'border-radius:6px',
      'font-size:14px', 'font-weight:500', 'line-height:1.4',
      'max-width:90vw', 'box-shadow:0 4px 16px rgba(0,0,0,0.4)',
    ].join(';');
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out';
      t.style.opacity = '0';
      t.style.transform = 'translate(-50%, -10px)';
      setTimeout(function () { t.remove(); }, 400);
    }, 4000);
  }

  // ── enforceLimit: the workhorse ─────────────────────────────────────
  // Returns a promise resolving to true if it had to clamp anything.
  var enforcing = false;
  function enforceLimit() {
    if (enforcing) {
      // Wait for the in-flight enforce to finish.
      return new Promise(function (resolve) {
        var t = setInterval(function () {
          if (!enforcing) { clearInterval(t); resolve(false); }
        }, 60);
      });
    }
    enforcing = true;
    return fetchCart().then(function (cart) {
      var updates = {};
      var triggered = false;
      (cart.items || []).forEach(function (item) {
        if (!isBoxSku(item.sku)) return;
        if ((item.quantity || 0) > LIMIT) {
          updates[item.key] = LIMIT;
          triggered = true;
        }
      });
      if (!triggered) return false;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function (r) { return r.json(); }).then(function () {
        showToast();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tcc-booster-limit' }); }
          catch (e) {}
        }
        return true;
      });
    }).catch(function (e) {
      console.warn('[tcc-booster-limit] enforce error', e);
      return false;
    }).then(function (rolled) {
      enforcing = false;
      return rolled;
    });
  }

  // ── (1) checkout / payment-button click interception ────────────────
  // Captured at the very top of the DOM so we run before Spotlight's
  // own handlers. If the cart needed clamping, the original click is
  // swallowed and the user is forced to click again on the corrected cart.
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'button[name="add"][value*="checkout"]',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]',
    'a[href*="/checkouts/"]',
    'a[href$="/cart/checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '#cart-drawer-checkout',
    '.cart__checkout-button',
    '.cart__submit-controls button',
    '.shopify-payment-button button',
    '.shopify-payment-button__button',
    'shop-pay-wallet-button',
    'apple-pay-button',
    '[data-shopify="payment-button"]',
    '[data-paypal-button]',
    // catch-all by visible text — last resort for theme variations
    'button.button--primary',
  ].join(', ');

  // Visible-text fallback: any button whose label looks like a checkout CTA.
  function isCheckoutButton(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toLowerCase();
    if (tag !== 'button' && tag !== 'input' && tag !== 'a') return false;
    try {
      if (el.matches(CHECKOUT_SELECTOR)) return true;
    } catch (e) {}
    var label = (el.textContent || el.value || '').trim().toLowerCase();
    if (/^(check\s*out|continue to (?:checkout|payment)|proceed to checkout|place order|pay now)$/i.test(label)) {
      return true;
    }
    return false;
  }

  var bypassNext = false;
  function handleCheckoutInteraction(e) {
    if (bypassNext) { bypassNext = false; return; }
    var t = e.target;
    var match = null;
    while (t && t !== document) {
      if (isCheckoutButton(t)) { match = t; break; }
      t = t.parentNode;
    }
    if (!match) return;
    // Capture-phase intercept. Stop the click + re-issue once cart is clean.
    e.preventDefault();
    e.stopImmediatePropagation();
    enforceLimit().then(function (rolled) {
      if (rolled) return;  // clamp happened; user re-confirms on corrected cart
      bypassNext = true;
      try { match.click(); } catch (ee) { match.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })); }
    });
  }
  // Mobile Safari fires touchend before click for taps. Catch both — whichever
  // fires first wins; bypassNext stops the recursion.
  document.addEventListener('click', handleCheckoutInteraction, true);
  document.addEventListener('touchend', handleCheckoutInteraction, true);

  // Also catch form submits. Spotlight's cart form posts to /cart with a
  // submit button named "checkout" — Shopify backend then 302s to /checkout.
  // So we must check the submitter, not just the form action.
  var bypassSubmit = false;
  document.addEventListener('submit', function (e) {
    if (bypassSubmit) { bypassSubmit = false; return; }
    var f = e.target;
    if (!f) return;
    var action = f.action || '';
    var submitter = e.submitter || null;
    var goesToCheckout = /\/checkout(\?|$|#|\/)/.test(action);
    var goesToCart = /\/cart\/add/.test(action);
    var submitterIsCheckout = submitter && isCheckoutButton(submitter);
    // Spotlight: form#cart posts to /cart but submitter has name=checkout
    var cartFormWithCheckoutBtn = action.endsWith('/cart') &&
      submitter && (submitter.name === 'checkout' || submitter.id === 'checkout');
    if (goesToCheckout || submitterIsCheckout || cartFormWithCheckoutBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      enforceLimit().then(function (rolled) {
        if (rolled) return;
        bypassSubmit = true;
        // Re-submit. If a specific submitter was used, requestSubmit preserves it.
        try {
          if (submitter && typeof f.requestSubmit === 'function') f.requestSubmit(submitter);
          else f.submit();
        } catch (ee) { f.submit(); }
      });
    } else if (goesToCart) {
      setTimeout(enforceLimit, 250);
    }
  }, true);

  // ── (2) periodic poll ───────────────────────────────────────────────
  // Brute-force catch-all. /cart.js is cheap (edge-cached static JSON).
  setInterval(enforceLimit, POLL_MS);

  // ── (3) fetch + XHR wrap ────────────────────────────────────────────
  // Fast-path: clamp within ~50ms of an AJAX cart mutation.
  var origFetch = window.fetch.bind(window);
  window.fetch = function () {
    var args = arguments;
    var input = args[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = origFetch.apply(null, args);
    if (typeof url === 'string' && /\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(url)) {
      result.then(function () { setTimeout(enforceLimit, 50); });
    }
    return result;
  };
  var origXhrOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(enforceLimit, 50); });
    }
    return origXhrOpen.apply(this, arguments);
  };

  // ── initial enforcement on page load ────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceLimit);
  } else {
    enforceLimit();
  }

  // ── (4) cart-page passive warning ───────────────────────────────────
  function injectWarning(row) {
    if (row.querySelector('.tcc-box-limit-warning')) return;
    var w = document.createElement('div');
    w.className = 'tcc-box-limit-warning';
    w.style.cssText = 'color:#cba135;border:1px solid #cba135;padding:8px 12px;border-radius:4px;margin-top:8px;font-size:13px;line-height:1.4;background:rgba(203,161,53,0.08);';
    w.textContent = MESSAGE;
    var details = row.querySelector('.cart-item__details') || row;
    details.appendChild(w);
  }
  function clearWarnings() {
    document.querySelectorAll('.tcc-box-limit-warning').forEach(function (el) { el.remove(); });
  }
  function rowForIndex(i) { return document.getElementById('CartItem-' + (i + 1)); }
  // Cap the qty input + disable the "+" button on every BOX line, so the
  // user can't tap their way to 6. Spotlight markup:
  //   <quantity-input>
  //     <button name="minus"> <input id="Quantity-{idx+1}" max=".."> <button name="plus">
  //   </quantity-input>
  function applyInputCap(item, idx) {
    var qtyInput = document.getElementById('Quantity-' + (idx + 1));
    if (!qtyInput) return;
    qtyInput.setAttribute('max', String(LIMIT));
    qtyInput.max = String(LIMIT);
    if (parseInt(qtyInput.value, 10) > LIMIT) qtyInput.value = String(LIMIT);
    var wrapper = qtyInput.closest('quantity-input') || qtyInput.parentElement;
    if (wrapper) {
      var plus = wrapper.querySelector('button[name="plus"]');
      if (plus) {
        if ((item.quantity || 0) >= LIMIT) {
          plus.setAttribute('disabled', 'disabled');
          plus.style.opacity = '0.4';
          plus.style.cursor = 'not-allowed';
          plus.setAttribute('aria-disabled', 'true');
        } else {
          plus.removeAttribute('disabled');
          plus.style.opacity = '';
          plus.style.cursor = '';
          plus.removeAttribute('aria-disabled');
        }
      }
    }
  }

  function scanCart() {
    fetchCart().then(function (cart) {
      clearWarnings();
      (cart.items || []).forEach(function (item, idx) {
        if (!isBoxSku(item.sku)) return;
        applyInputCap(item, idx);
        if ((item.quantity || 0) < LIMIT) return;
        var row = rowForIndex(idx);
        if (row) injectWarning(row);
      });
    }).catch(function () {});
  }

  // Block click on a disabled "+" button before Spotlight's own handler runs.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="plus"][disabled]');
    if (btn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showToast();
    }
  }, true);
  document.addEventListener('touchend', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="plus"][disabled]');
    if (btn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showToast();
    }
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCart);
  } else {
    scanCart();
  }
  document.addEventListener('cart:updated', scanCart);
  document.addEventListener('cart:refresh', scanCart);

  // ── PDP qty cap for booster-box products ────────────────────────────
  // On product pages (/products/...), if the product is a Booster Box,
  // cap the qty input at LIMIT, disable the "+" button at LIMIT, and
  // refuse cart-add submits with qty > LIMIT.
  function isBoxProductPage() {
    if (!/^\/products\//.test(window.location.pathname)) return false;
    try {
      var t = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product
        && window.ShopifyAnalytics.meta.product.type;
      if (t && /Booster Box$/i.test(t)) return true;
    } catch (e) {}
    // Fallback: read product type from the inline JSON-LD <script type="application/ld+json">
    try {
      var scripts = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < scripts.length; i++) {
        var j = JSON.parse(scripts[i].textContent || '{}');
        var category = j['@type'] === 'Product' ? j.category : null;
        if (category && /Booster Box$/i.test(category)) return true;
      }
    } catch (e) {}
    return false;
  }

  function setBoxQtyLabel() {
    // Replace "Quantity" → "Order limit of 5" in the PDP qty label for BOX
    // products. Preserves the nested "<N in cart>" span.
    document.querySelectorAll('label.quantity__label').forEach(function (lbl) {
      var nodes = lbl.childNodes;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.nodeType === 3 /* text */) {
          var txt = n.textContent;
          if (/Quantity/i.test(txt)) {
            n.textContent = txt.replace(/Quantity/i, 'Order limit of ' + LIMIT);
            break;
          }
        }
      }
    });
  }

  function capPdpQty() {
    if (!isBoxProductPage()) return;
    setBoxQtyLabel();
    var inputs = document.querySelectorAll('input.quantity__input[name="quantity"]');
    inputs.forEach(function (input) {
      input.setAttribute('max', String(LIMIT));
      input.max = String(LIMIT);
      if ((parseInt(input.value, 10) || 1) > LIMIT) input.value = String(LIMIT);
      var wrapper = input.closest('quantity-input');
      var plus = wrapper && wrapper.querySelector('button[name="plus"]');
      function syncPlus() {
        if (!plus) return;
        var v = parseInt(input.value, 10) || 0;
        if (v >= LIMIT) {
          plus.setAttribute('disabled', 'disabled');
          plus.style.opacity = '0.4';
          plus.style.cursor = 'not-allowed';
          plus.setAttribute('aria-disabled', 'true');
        } else {
          plus.removeAttribute('disabled');
          plus.style.opacity = '';
          plus.style.cursor = '';
          plus.removeAttribute('aria-disabled');
        }
      }
      syncPlus();
      input.addEventListener('input', syncPlus);
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > LIMIT) { input.value = String(LIMIT); showToast(); }
        syncPlus();
      });
    });

    // Last-line defence on product-form submits.
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action) return;
      if (!/\/cart\/add/.test(f.action)) return;
      var qInput = f.querySelector('input[name="quantity"]');
      var qty = parseInt(qInput && qInput.value, 10) || 1;
      if (qty > LIMIT) {
        if (qInput) qInput.value = String(LIMIT);
        showToast();
        // Let the form submit go through with the clamped value.
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', capPdpQty);
  } else {
    capPdpQty();
  }
  // ShopifyAnalytics.meta is populated late on some themes; re-check after load.
  window.addEventListener('load', capPdpQty);
})();
